export function getOpacity({ percent }: { percent: number }) {
  const opacity = 0.16 + Math.min(percent / 35, 1) * 0.48;
  return Math.round(opacity * 100) / 100;
}
